import { GeometryType, PointDc, PolyDc, PolygonDc } from "@evergis/api";

export type UnknownGeometry = PointDc | PolyDc | PolygonDc;

export const isPointGeometry = (geometry?: UnknownGeometry): geometry is PointDc => {
  return !!geometry && geometry.type === GeometryType.Point;
};

export const isPolyGeometry = (geometry?: UnknownGeometry): geometry is PolyDc => {
  return !!geometry && geometry.type === GeometryType.Polyline;
};
export const isPolygonGeometry = (geometry?: UnknownGeometry): geometry is PolygonDc => {
  return !!geometry && geometry.type === GeometryType.Polygon;
};
